/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class UpsellProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-upsell-swiper]',
    };
    
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          initialSlide: 0,
          spaceBetween: 0,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          breakpoints: {
            750: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 6,
            },
          }
        },
      },
    };
  }

  connectedCallback() {
    this.init();

    document.addEventListener('alexa:start-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = false;
    });

    document.addEventListener('alexa:end-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = true;
    });

    // Destroy Swiper on window resize
    if (window.innerWidth <= 750 && this.settings.instances.slider !== undefined) {
      this.settings.instances.slider.destroy();
      this.settings.instances.slider = undefined;
    } 
    else if (window.innerWidth > 750 && this.settings.instances.slider === undefined) {
      this.settings.instances.slider = new Swiper(this.settings.elements.slider, this.settings.options.slider);
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 750 && this.settings.instances.slider !== undefined) {
        this.settings.instances.slider.destroy();
        this.settings.instances.slider = undefined;
      } 
      else if (window.innerWidth > 750 && this.settings.instances.slider === undefined) {
        this.settings.instances.slider = new Swiper(this.settings.elements.slider, this.settings.options.slider);
      }
    });
  }

  init() {
    if (!this.settings.elements.slider)
      return;
    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }
}

customElements.define('upsell-products', UpsellProducts);
